<template>
  <div class="Main">
    <van-nav-bar
        fixed
        :border="false"
        :title="$t('home.qywh')"
        left-arrow
        @click-left="$router.go(-1)"
    />
    <div class="PageBox">
      <div class="ScrollBox">
		<div style="margin: .25rem;width:calc(100% - 20px);height:188px;margin: 10px;background-image:url('./static/images/top.png');background-size:100% 188px;"></div>
		<div style="margin: .25rem;line-height: 1.2rem;margin:20px 10px" v-html="InitData.qywh[0].content"></div>
         <!-- <van-cell size="large" :title="item.title" is-link v-for="item in InitData.qywh" :key="item.id" @click="openShow(item)" />
        <van-empty :description="$t('home.qywh')" v-if="!InitData.qywh.length" /> -->
      </div>
    </div>
    <!-- <van-popup v-model="showCon" position="bottom" closeable close-on-popstate  style="width: 100%;height: 100%;background-color:rgb(255, 255, 255);color:#fff;">
      <div class="ScrollBox">
        <h3 style="text-align: center;margin-bottom: 20px;color:#333">{{infoData.title}}</h3>
        <div class="Content" style="text-align: justify;color:#333" v-html="infoData.content"></div>
      </div>
    </van-popup> -->
  </div>
</template>

<script>
export default {
  name: 'Help',
  components: {
  },
  props: [],
  data() {
    return {
      showCon: false,
      infoData: '',
    }
  },
  computed: {

  },
  watch: {

  },
  created() {

  },
  mounted() {

  },
  activated() {

  },
  destroyed() {

  },
  methods: {
    openShow(data) {
      this.showCon = true
      this.infoData = data
    }
  }
}
</script>
<style lang="scss" scoped>
.ScrollBox{
	background-color: #fff;
}
::v-deep .van-nav-bar__content {
  background: linear-gradient(to right,$theme-shallow-color, $theme-color);
  color: #fff;
}
::v-deep .van-nav-bar__title {
  color: #fff;
}
::v-deep .van-nav-bar .van-icon {
  color: #fff !important;
}
</style>